import { TmTableError } from '@/core/error/table/tmTableError'

export class TmTableGroupingError extends TmTableError {
  public name = 'TmTableGroupingError'
}
